export function loadTranslations({ baseUrl, translationsName, language }) {
  const url = baseUrl + translationsName + '_' + language + '.json';

  return fetch(url).then((res) => res.json());
}
